import React , { useState, useEffect } from 'react';
import GraphTypesConfig from '../../layouts/graph/GraphTypesConfig';
import StaticGraphTypesConfig from '../../layouts/graph/StaticGraphTypesConfig';
import { Box, Grid } from '@mui/material';

const EmptyChart = ({ chartType }) => {
    const [selectedChartType, setSelectedChartType] = useState({})

    useEffect(() => {
        let graphType;
        graphType = GraphTypesConfig.find((obj) => obj.value === chartType);
        if(!graphType) {
          graphType = StaticGraphTypesConfig.find((obj) => obj.value === chartType);
        }
        setSelectedChartType({...graphType});
    }, [chartType]);

    return (
        <Grid container className="box-center" >
            <Grid className='text-center'>
                <h2 className='content-heading'>You need to add or remove fields</h2>
                <p className='content-text'>{selectedChartType?.label} Requires:</p>
                <p className='content-text'>{selectedChartType?.requireField?.label}</p>
            </Grid>
        </Grid>
    )
}

export default EmptyChart;